import React from "react";
import chunk from "lodash/chunk";
import { DomParser } from "../utils/dom-parser";
import { WidgetBox, Empty, Link, Action } from "../components";
import { renderDate } from "../utils/text-display";

const YourActionItems = ({ title = "Certifications" }) => {
    const parseDataFromDOM = () => {
        const domParser = new DomParser(
            "div[data-tag='pnlActionItems'] table.CsList > tbody > tr > td"
        );
        const columns = domParser.columns;
        return chunk(columns, 2)
            .map(row => {
                const [td1, td2] = row;
                return {
                    link: domParser.singleAnchor(td1),
                    dueDate: domParser.dateSpan(td2)
                };
            })
            .sort((a, b) => a.dueDate - b.dueDate);
    };

    const data = parseDataFromDOM();

    let titleLink = null;
    let titleLinkEl = document.querySelector(
        "div[data-tag='pnlActionItems'] a.titleLink"
    );

    if (titleLinkEl) {
        titleLink = titleLinkEl.getAttribute("href");
    }

    return (
        <WidgetBox
            title={title}
            icon="clipboard"
            noPadding
            titleLink={titleLink}
        >
            <div style={{ padding: "0px 45px 5px 45px" }} className="v-list">
                <Empty isEmpty={data.length === 0} />
                {data.map((o, i) => (
                    <div key={i} className="v-list-item">
                        <Action classes="v-list-item__title" {...o.link} />
                        <p className="v-list-item__date">
                            {renderDate(o.dueDate, "Due date: ")}
                        </p>
                    </div>
                ))}
            </div>
            {titleLink && (
                <div style={{ padding: "0px 45px 25px 45px" }}>
                    <Link text="See all items" url={titleLink} />
                </div>
            )}
        </WidgetBox>
    );
};

export default YourActionItems;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/widgets/your-action-items.js